import React from 'react';
import { useBuild } from '../../contexts/BuildContext';
import QueryModes from '../../search/QueryModes';

// hyperliquid-items: per-market metadata for Hyperliquid perpetual / spot
// markets (one doc per market_id like `hyperliquid:hypercore-mainnet:perp:@296`).
// Distinct from `hyperliquid-trades` which is the per-trade event stream.
const SORT_OPTIONS = [
  { id: 'updated_at', label: 'updated_at' },
  { id: 'all_mids_price', label: 'all_mids_price' },
  { id: 'null', label: 'None' },
];

const FILTER_TYPE_OPTIONS = [
  { id: 'item_ids', label: 'Market IDs' },
  { id: 'market_filters', label: 'Coin / Class / Network' },
  { id: 'date', label: 'Date Range' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const HyperliquidMarketsQuery = () => {
  const { selectedIndex } = useBuild();
  return (
    <QueryModes
      source={selectedIndex}
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={FILTER_TYPE_OPTIONS}
    />
  );
};

export default HyperliquidMarketsQuery;
